/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractStandardOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/AbstractStandardOperandExpressionNodeConverter";
import { AbImmutableRecord } from "abreact/utils/AbImmutableRecord";
import { NullUtils } from "abweb/utils/NullUtils";
import { Optional } from "abweb/utils/optional/Optional";
import Immutable from "immutable";
// import AbstractLeafOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractLeafOperandValue;
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;

export class AbstractLeafOperandExpressionNodeConverter extends AbstractStandardOperandExpressionNodeConverter {
  getStateWithoutNodeType(expExpressionNode) {
    return {
      ...super.getStateWithoutNodeType(expExpressionNode),
      value: this.getValue(expExpressionNode),
      valueCategoryID: NullUtils.getRequiredPropertyValue(expExpressionNode, "categoryID"),
      valueTypeIDs: Immutable.List(NullUtils.getRequiredPropertyValue(expExpressionNode, "valueTypeIDs")),
      multiple: expExpressionNode.multiple ?? false,
      typeQualifier: expExpressionNode.typeQualifier,
      operandName: NullUtils.getRequiredPropertyValue(expExpressionNode, "operandName")
    };
  }
  getValue({
    value,
    listValue
  }) {
    return value ?? Optional.of(listValue).map(AbImmutableRecord.State.Object.from).get();
  }
}
//# sourceMappingURL=AbstractLeafOperandExpressionNodeConverter.js.map
